import { request } from '@/utils/request'

export interface CreateFunnel {
  name: string
  templateType: 'one_page_checkout' | 'three_pages_checkout' | 'paypal_with_upsell'
  postupsellFunnelType: 'webc' | null
  newPostupsellFlow: boolean
}

interface UpdateFunnel {
  id: string
  name: string
}

interface PostUpsell {
  id: number;
  postupsell: any;
}


export async function getFunnelList() {
  return request<any>(`/api/shopify-admin/funnels`, {
    method: 'GET',
  })
}

export async function createFunnel(params: CreateFunnel) {
  return request<any>(`/api/shopify-admin/funnels`, {
    method: 'POST',
    data: params,
  })
}

export async function updateFunnelName(params: UpdateFunnel) {
  return request<any>(`/api/shopify-admin/funnels/name`, {
    method: 'PUT',
    data: params,
  })
}

export async function deleteFunnel(id: string) {
  return request<any>(`/api/shopify-admin/funnels/${id}`, {
    method: 'DELETE',
  })
}

export async function updateFunnelPostUpsell(params: PostUpsell) {
  return request<any>(`/api/shopify-admin/funnels/postupsell`, {
    method: "PUT",
    data: params,
  });
}

export async function updateFunnel(params: any) {
  return request<any>(`/api/shopify-admin/funnels`, {
    method: "PUT",
    data: params,
  });
}

// 获取funnel详情 根据funnelId
export async function getFunnelById(id: number) {
  return request<any>(`/api/shopify-admin/funnels/${id}`, {
    method: "GET"
  });
}

/**
 * 更新 funnel 模板
 * @param params
 * @returns
 */
export async function updateFunnelTemplate(params: any) { 
    return request<any>(`/api/shopify-admin/funnels/${params.funnel.template.id}/template`, {
    method: 'PUT',
    data: params,
  })
}